import {
  call, put, select, takeEvery, takeLatest,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import selectors from '@/selectors';
import findResult from '@/utils/resultsHelper';
import {
  fetchDatasourceFeatures,
  fetchDatasourceFeaturesError,
  fetchDatasourceFeaturesSuccess,
  fetchDatasourceSettingsError,
  fetchDatasourceSettingsSuccess,
  fetchDatasourceTypes,
  fetchDatasourceTypesError,
  fetchDatasourceTypesSuccess,
  saveDatasourceSettingsError,
  saveDatasourceSettingsSuccess,
  testDatasourceSettingsError,
  testDatasourceSettingsSuccess,
} from '../actions';
import actions, { datasetDatasourceFeatureActions } from '../constants';
import DatasourceService from '../service';

export function* datasourceFeatures({ category, code }) {
  const { response, error } = yield call(callAdapter, DatasourceService.datasourceFeatures(code));
  if (error) {
    yield put(fetchDatasourceFeaturesError(category, code, error));
  } else {
    yield put(fetchDatasourceFeaturesSuccess(category, code, response));
  }
}

export function* saveDatasourceSettings({ category, code }) {
  const items = yield select(selectors.datasourceSettings);
  const active = yield select(selectors.activeDatasourceSettings);
  const item = active.open ? active : findResult(items, category, code).copy;

  const { error } = yield call(callAdapter, DatasourceService.updateDatasetDatasource(item));
  if (error) {
    yield put(saveDatasourceSettingsError(category, code, error));
  } else {
    yield put(saveDatasourceSettingsSuccess(category, code, item.title));
    yield put(fetchDatasourceFeatures('open', code));
  }
}

export function* datasourceSettings({ category, code }) {
  const { response, error } = yield call(callAdapter, DatasourceService.datasourceSettings(code));
  if (error) {
    yield put(fetchDatasourceSettingsError(category, code, error));
  } else {
    yield put(fetchDatasourceSettingsSuccess(category, code, response, false));
  }
  yield put(fetchDatasourceTypes('all'));
}

export function* testDatasource({ category, code }) {
  const items = yield select(selectors.datasourceSettings);
  const active = yield select(selectors.activeDatasourceSettings);
  const item = active.open ? active : findResult(items, category, code).copy;
  const serviceFn = item.isNew ? DatasourceService.testDatasource : DatasourceService.testDatsetDatasource;

  const { response, error } = yield call(callAdapter, serviceFn(item));
  if (error) {
    yield put(testDatasourceSettingsError(category, code, error));
  } else {
    yield put(testDatasourceSettingsSuccess(category, code, response));
  }
}

export function* datasourceTypes({ category }) {
  const { response, error } = yield call(callAdapter, DatasourceService.datasourceTypes());
  if (error) {
    yield put(fetchDatasourceTypesError(category, error));
  } else {
    yield put(fetchDatasourceTypesSuccess(category, response));
  }
}

export default function* datasourceApi() {
  yield takeEvery(datasetDatasourceFeatureActions.FETCH_DATASOURCE_FEATURES, datasourceFeatures);
  yield takeEvery(actions.FETCH_DATASOURCE_SETTINGS, datasourceSettings);
  yield takeEvery(actions.FETCH_DATASOURCE_TYPES, datasourceTypes);
  yield takeLatest(actions.SHOW_DATASOURCE_SETTINGS, datasourceSettings);
  yield takeLatest(actions.SAVE_DATASOURCE_SETTINGS, saveDatasourceSettings);
  yield takeLatest(actions.TEST_DATASOURCE_SETTINGS, testDatasource);
}
